import * as React from 'react';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';

const Timeline1921 = () => (
  <Timeline>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> January 2020 </b>
        <br />
        <a href="https://regents.universityofcalifornia.edu/regmeet/jan20/f12.pdf" target="_blank" rel="noreferrer">
          <em> A memo to the Regents details a donor&apos;s offer to finance UC Berkeley&apos;s Gateway Project. </em>
        </a>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <p>
          Anonymously deemed as “among the University of California&apos;s most generous philanthropic partners,” a donor offers to pay for the design, development and construction of an existing plan for a student housing project.
        </p>
        <p>
          The Gateway was to be built on five University-owned parcels of the six parcels composing a city block just west of campus.
        </p>
        <p>
          The only parcel on the block the UC did not own was 1921 Walnut St.
        </p>
        <br />
      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> Monday, June 29, 2020 </b>
        <br />
        <a href="https://www.dailycal.org/2020/07/01/canary-in-the-coal-mine-berkeley-residents-protest-for-affordable-housing/" target="_blank" rel="noreferrer">
          <em> “I have a lot of history here.” </em>
        </a>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <p>
          About 25 gather to protest the university&apos;s plan to purchase 1921 Walnut St.
        </p>
        <p>
          A resident since 1989, Davone Riddick, said, “This apartment really means a lot to me because I grew up here, and I have a lot of history here.​”
        </p>
        <p>
          Backing up the tenants were members of the Berkeley Tenants Union and the Eviction Defense Center. Representatives from Arreguín&apos;s office, as well as the office of Councilmember Kate Harrison, were there.
        </p>
        <br />
      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> July 2020 </b>
        <br />
        <em> The university purchases 1921 Walnut St. </em>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <p />
      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> Monday August 3, 2020 </b>
        <br />
        <a href="https://www.dailycal.org/2020/08/03/were-not-going-to-stop-1921-walnut-st-tenants-protest-uc-acquisition/" target="_blank" rel="noreferrer">
          <em> “We&apos;re not going to stop until we get UC to listen to us.” </em>
        </a>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <p>
          Tenants and supporters protest outside the UC Office of the President in Oakland.
        </p>
        <p>
          A group of about 20 protestors and tenants were joined by members of the Berkeley Rent Stabilization Board, Berkeley Tenants Union, Berkeley Citizens Action, Eviction Defense Center and Bay Area Tenant and Neighborhood Councils.
        </p>
        <br />

      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> Tuesday, January 26, 2021 </b>
        <br />
        <em>
          1921 Walnut St. residents are told they must vacate.
        </em>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <p> UC Berkeley officials inform residents they must move out of the building, offering a monetary incentive of $54,000 or more, in preparation for its demolition. According to campus spokesperson Dan Mogulof, relocation packages “easily reach six figures.” </p>
        <br />
      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> Monday, February 22, 2021 </b>
        <br />
        <a href="https://news.berkeley.edu/2021/02/22/an-update-from-chancellor-christ-on-two-uc-berkeley-student-housing-projects/" target="_blank" rel="noreferrer">
          <em> A place for transfer students </em>
        </a>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <p>
          In an email to all UC Berkeley students, Chancellor Carol Christ details plans for Anchor House, a student housing project aimed at housing and supporting transfer students.
        </p>
        <p>
          In the email, Christ noted that most transfer students at UC Berkeley, who are more likely to come from low-income families and communities of color, come from California Community Colleges. Transfer students often feel disconnected from the larger campus community, Christ added, a struggle that could be remedied by Anchor House&apos;s prioritization of transfer students.
        </p>
        <p>
          Project was to be built upon 1921 Walnut St. and the five other university-owned parcels on the block.
        </p>
        <p>
          Christ said the donation to fund its design and construction is “the largest philanthropic gift in our history.”
        </p>
        <br />
      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> Wednesday, March 17, 2021 </b>
        <br />
        <a href="https://www.dailycal.org/2021/03/18/we-need-to-stand-together-as-tenants-protesters-oppose-1921-walnut-st-eviction/" target="_blank" rel="noreferrer">
          <em> “We need to stand together as tenants.” </em>
        </a>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <p>
          About 40 community members gather outside 1921 Walnut St. to protest campus&apos;s plan to evict tenants to build Anchor House.
        </p>
        <p>
          On behalf of the City Council, Mayor Jesse Arreguín voices support for the protest, as the cost of rental housing is “skyrocketing” across Berkeley.
        </p>
        <p>
          UC Berkeley Capital Strategies spokesperson Kyle Gibson said in an email campus is committed to accommodating tenants during their relocation. As well, Gibson said UC Berkeley acknowledges the challenges of relocation and will not require tenants to “permanently relocate before the end of August 2021, at the earliest.”
        </p>
        <br />
      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> Saturday, April 24, 2021 </b>
        <br />
        <a href="https://www.dailycal.org/2021/04/27/strongly-objecting-community-members-march-against-uc-berkeley-development-plans-at-peoples-park-1921-walnut-st/" target="_blank" rel="noreferrer">
          <em> About 100 protest development plans for 1921 Walnut St. and People&apos;s Park. </em>
        </a>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <p>
          Community members march against campus plans to redevelop 1921 Walnut St. and People&apos;s Park.
        </p>
        <p>
          Amid the COVID-19 pandemic, tenants, including Natalie Logusch, expressed concerns about eviction. Logusch claims she and other tenants attempted to hold a community listening session with UC Berkeley multiple times but were met with disinterest from campus.
        </p>
        <p>
          Mogulof denied these claims in an email, where he said tenants were encouraged to reach out to UC Berkeley regarding their relocation and rights under UC system policy.
        </p>
        <br />
      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> Wednesday, July 21, 2021 </b>
        <br />
        <a href="https://www.dailycal.org/2021/07/23/here-because-i-am-mad-community-activists-protest-uc-board-of-regents/" target="_blank" rel="noreferrer">
          <em> “I&apos;m here because I am mad.” </em>
        </a>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <p>
          The Coalition for a Truly Public UC gathered in downtown Oakland at 8 a.m. to protest the UC Board of Regents, including campus&apos;s plans to redevelop People&apos;s Park and 1921 Walnut St.
        </p>
        <p>
          Among the protestors were then-ASUC senator-elect Amanda Hill and UC Cops Off Campus organizer Katie Latimer.
        </p>
        <br />
      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> Tuesday, July 27, 2021 </b>
        <br />
        <a href="https://www.jessearreguin.com/press-releases/2021/7/14/city-council-approves-historic-agreement-with-university-of-california-berkeley" target="_blank" rel="noreferrer">
          <em> Campus and city reach an $82.6M settlement. </em>
        </a>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <p>
          The
          {' '}
          <a href="https://www.cityofberkeley.info/uploadedFiles/City_Manager/Level_1_-_Miscellaneous/FULLY%20EXECUTED%20SETTLEMENT%20AGREEMENT.pdf" target="_blank" rel="noreferrer">$82.6 million settlement</a>
          {' '}

          includes a $920,000 payment to recognize campus&apos;s planned demolition of the eight rent-controlled units at 1921 Walnut St.
        </p>
        <p>
          As part of the agreement, the city cannot legally challenge Anchor House, among other university projects.
        </p>
        <p>
          The settlement also detailed that campus would explore relocating the building but only if the relocation does not increase the time needed to complete the project or delay the construction of Anchor House.
        </p>
        <p>
          The settlement was signed by Arreguín.
        </p>
        <br />
      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> Monday, August 2, 2021 </b>
        <br />
        <a href="https://www.berkeleyside.org/2021/08/02/op-ed-new-campus-agreement-is-an-80-million-win-for-the-city" target="_blank" rel="noreferrer">
          <em> Berkeleyside publishes an opinion article by Arreguín and Councilmember Rigel Robinson. </em>
        </a>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        {/* <br /> */}
        <p>
          While they call the $82.6 million settlement a “win for the city,” they express frustration over campus&apos;s intention to evict residents and demolish 1921 Walnut St.
        </p>
        <br />
      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> September 2021 </b>
        <br />
        <a href="https://www.dailycal.org/2021/09/27/last-tenants-of-1921-walnut-st-agree-to-vacate-affordable-units/" target="_blank" rel="noreferrer">
          <em> Tenants accept relocation packages and agree to leave. </em>
        </a>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <p>
          The last of the 1921 Walnut St. tenants agree to vacate their rentals with relocation packages that could reach six figures.
        </p>
        <p>
          In response to the tenants&apos; decisions, ASUC Senator Kalliope Zervas expresses concern over the relationship between city and campus, increasing houselessness and the preservation of low-income housing.
        </p>
        <br />
      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> Thursday, December 16, 2021 </b>
        <br />
        <a href="https://www.berkeleyside.org/2021/12/16/student-housing-uc-berkeley-walnut-street-demolition" target="_blank" rel="noreferrer">
          <em> 1921 Walnut St. is demolished. </em>
        </a>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
        <TimelineConnector />
      </TimelineSeparator>
      <TimelineContent>
        <p>
          The newly cleared land will make way for the Helen Diller Anchor House.
        </p>
        <br />
      </TimelineContent>
    </TimelineItem>

    <TimelineItem>
      <TimelineOppositeContent color="text.secondary">
        <b> Monday, January 31, 2022 </b>
        <br />
        <a href="https://www.dailycal.org/2022/02/04/level-playing-field-uc-berkeley-breaks-ground-on-anchor-house/" target="_blank" rel="noreferrer">
          <em> UC Berkeley breaks ground on Anchor House. </em>
        </a>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot />
      </TimelineSeparator>
      <TimelineContent>
        <p>
          While the project&apos;s construction is fully funded by the Helen Diller Foundation, the revenue from the businesses within the building will help secure scholarships for first-generation and underrepresented students.
        </p>
        <p>
          While the tenants of 1921 Walnut St. were afforded relocation packages by the university, Logusch claimed some tenants had to leave Berkeley, or even California, altogether.
        </p>
        <br />
      </TimelineContent>
    </TimelineItem>

  </Timeline>
);

export default Timeline1921;
